import { useEffect, useState } from "react";
import "./App.css";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
export const Wallet = ({ renderer }) => {
  const [balance, setBalance] = useState(0);
  const [cloud, setCloud] = useState(global.getProfileData());
  const [loading, setLoading] = useState(true);
  const [anim, setAnim] = useState("");
  useEffect(() => {
    if (!localStorage.getItem("EMRBALANCE")) {
      localStorage.setItem("EMRBALANCE", "0");
    }
    console.log("renderer", renderer);
    if (!renderer || renderer == "") renderer = 0;
    var r = parseInt(renderer);
    var b = localStorage.getItem("EMRBALANCE");

    b = parseInt(b);
    if (isNaN(b)) b = 0;
    b = b + r;
    localStorage.setItem("EMRBALANCE", b);
    setBalance(b);
    setAnim("animate__animated animate__flipInX");
    setTimeout(function () {
      setAnim("");
    }, 2000);
  }, [renderer]);

  const db = getFirestore();

  async function getTelegramUser(tgUserid) {
    try {
      const q = query(
        collection(db, "telegram_users"),
        where("tgUserid", "==", tgUserid)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const userData = querySnapshot.docs[0].data();
        console.log("User Data:", userData);
        setCloud({ ...cloud, userData: userData });
        setLoading(false);
        return userData;
      } else {
        console.log("No user found with tgUserid:", tgUserid);
        return null;
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return null;
    }
  }

  const [tgUserid, setTgUserId] = useState(0);
  useEffect(() => {
    setTgUserId(parseInt(localStorage.getItem("TGUSERID")));

    getTelegramUser(parseInt(localStorage.getItem("TGUSERID")));
  }, []);

  return (
    <>
      <div
        className={anim}
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 30,
        }}
      >
        <button
          className="btn btn-primary gradColor"
          onClick={() => {
            global.downloadApplication();
          }}
          style={{
            padding: "5px 15px",
            borderRadius: 20,
            fontSize: 13,
          }}
        >
          Balance: 0 EMRS ($ 0.00)
        </button>
      </div>
    </>
  );
};
